module.exports = __webpack_public_path__ + "static/media/colicolilogo.13ec84d0.webp";